module.exports = __webpack_public_path__ + "images/d6c2f13bedd612dbc4f5c87e839f3940.svg";